import { render } from "./HeaderIcon2Configer.vue?vue&type=template&id=1a80b127&scoped=true"
import script from "./HeaderIcon2Configer.vue?vue&type=script&lang=js"
export * from "./HeaderIcon2Configer.vue?vue&type=script&lang=js"

import "./HeaderIcon2Configer.vue?vue&type=style&index=0&id=1a80b127&lang=scss"
import "./HeaderIcon2Configer.vue?vue&type=style&index=1&id=1a80b127&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a80b127"]])

export default __exports__